__turbopack_context__.v({
  "activeDataroomsWrp": "quoteForm-module-scss-module__q8rG_W__activeDataroomsWrp",
  "buttonWrp": "quoteForm-module-scss-module__q8rG_W__buttonWrp",
  "checkbox": "quoteForm-module-scss-module__q8rG_W__checkbox",
  "currentDataroomProviderWrp": "quoteForm-module-scss-module__q8rG_W__currentDataroomProviderWrp",
  "firstNameWrp": "quoteForm-module-scss-module__q8rG_W__firstNameWrp",
  "form": "quoteForm-module-scss-module__q8rG_W__form",
  "formWrp": "quoteForm-module-scss-module__q8rG_W__formWrp",
  "lastNameWrp": "quoteForm-module-scss-module__q8rG_W__lastNameWrp",
  "recaptchaWrp": "quoteForm-module-scss-module__q8rG_W__recaptchaWrp",
});
